import React from 'react';
import { FormFeedback, FormGroup, Input, Label } from 'reactstrap';
import { positionOptions } from '../../../utils/displayHelper';

const PositionInput = (props: {
  position: string;
  updatePosition: (newPosition: string) => void;
  required?: boolean;
  invalid?: boolean;
  disabled?: boolean;
}) => {
  const { position, updatePosition, required, invalid, disabled } = props;
  return (
    <FormGroup floating>
      <Input
        id="position"
        name="position"
        type="select"
        value={position}
        onChange={(e) => updatePosition(e.target.value)}
        required={required}
        invalid={invalid}
        disabled={disabled}
      >
        <option key="default-position-select-option" value={''} disabled>
          Select Position
        </option>
        {positionOptions.map((position) => {
          return (
            <option key={position.code} value={position.code}>
              {position.label}
            </option>
          );
        })}
      </Input>
      <Label for="position">Position</Label>
      <FormFeedback>Position is required</FormFeedback>
    </FormGroup>
  );
};

export default PositionInput;
